__webpack_require__.p = "/Result-Summary-Component-Frontend-mentor/";